export function initialize(module: ng.IModule) {
    module.config(configure);

    configure.$inject = ["$stateProvider"];
} 

function configure(
    $stateProvider: ng.ui.IStateProvider) {

        $stateProvider

        /*
         * Lists
         */
        .state("app.lists", {
            url: "/lists",
            views: {
                "main-view@app": {
                    template: require('./lists.html'),
                    controller: "ListsController",
                    controllerAs: "vm"
                },
                "heading-view@app": {
                    template: "Lists"
                }
            }
        })
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/lists/lists.routes.ts